<div class="chart-outer">
  <h3>{{ chartLabel }}</h3>
  <div class="chart-container">
    <canvas #chart1 class="chart1"></canvas>
  </div>
</div>
